import script from "./B2bInvoiceResend.vue?vue&type=script&lang=js"
export * from "./B2bInvoiceResend.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__